import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

export const WhySection = () => {
  const advantages = [
    {
      id: 1,
      icon: <Check className="text-n-green" />,
      title: "Cotação e contratação simplificada ",
      text: <>100% online, em poucos cliques. Sem ligações, sem burocracia.</>,
    },
    {
      id: 2,
      icon: <Check className="text-n-green" />,
      title: "Área do cliente completa",
      text: <>Acompanhe seu transporte e solicite atendimento na plataforma.</>,
    },
    {
      id: 3,
      icon: <Check className="text-n-green" />,
      title: "Sua plataforma digital",
      text: <>+200 bases e 10.000 parceiros conectados por tecnologia.</>,
    },
    {
      id: 4,
      icon: <Check className="text-n-green" />,
      title: "Seguro completo",
      text: <>Cobertura ampla e simplificada, de ponta a ponta.</>,
    },
    {
      id: 5,
      icon: <Check className="text-n-green" />,
      title: "Vistoria digital",
      text: <>Mais segurança e transparência no processo</>,
    },
  ];
  return (
    <section id="como-funciona" className=" py-10 md:py-24">
      <div className="container">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div className="flex flex-col gap-8">
            <h2 className="rb-5 text-3xl font-semibold md:text-4xl lg:text-5xl text-n-green">
              Por que escolher a Nacional GO, a primeira plataforma de
              transporte de veículos?
            </h2>

            <p className=" text-n-text-neutral">
              Não é só sobre transportar veículos. É sobre fazer isso com
              tecnologia, segurança e total tranquilidade para você. A Nacional
              GO nasceu para simplificar a logística automotiva no Brasil — e
              por isso somos referência no setor.
              <br /> <br />
              Confira o que só a Nacional GO oferece:
            </p>

            <Link to="/fazer-cotacao">
              <Button id="btn-fazer-cotacao">
                Simular e contratar meu transporte
                <ArrowRight className="ml-2 " />
              </Button>
            </Link>
          </div>

          <div>
            <ul className="flex flex-col gap-4">
              {advantages.map((option) => (
                <li
                  key={option.id}
                  className="flex gap-3 border rounded-2xl h-[64px] items-center border-n-primary hover:bg-n-beige/20"
                >
                  <div className="flex items-center justify-center h-full min-w-10 rounded-l-2xl border-r border-n-primary bg-n-beige ">
                    {option.icon}
                  </div>
                  <div className="flex flex-col">
                    <h5 className="text-n-green font-bold text-sm md:text-md">
                      {option.title}
                    </h5>
                    <p className="text-n-text text-xs md:text-md">
                      {option.text}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
